<script setup>
import {ref, watch} from 'vue'
import {codePreview, formatDate, setButtonContentDefault, setButtonContentLoading} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import DocumentsDetailSimple from '@/views/documents/DocumentsDetailSimple.vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const props = defineProps({
  documentId: {type: Number, required: true},
  isNewOnboarding: {type: Boolean, required: false, default: false},
});
const emit = defineEmits(['confirm', 'cancel']);

const isOpen = ref(true)
const form = ref({
  owner: false,
  responsible: false,
  responsible_id: null
})

const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', form.value);
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}
</script>

<template>
  <TransitionRoot :show="isOpen" as="template">
    <div class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-xl" style="z-index: 1055">
        <div class="modal-content">
          <div class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <div class="modal-title">
                <h3>{{ t('documentDetailModal.preview_document') }}</h3>
              </div>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
              <div class="modal-body">
                <DocumentsDetailSimple :documentId="props.documentId" :isNewOnboarding="isNewOnboarding" :isModal="true"/>
              </div>
          </div>
        </div>
      </div>
    </div>
  </TransitionRoot>
</template>

